import axios from 'axios';
import { getHeaders } from '../../../services/agent.service';
import { getAgentData } from '../../../services/util';
import HttpService from '../../../services/http.service';
import { store } from '../../../context/store';

// Base API configuration

// Create API client with default config
const createApiClient = (config) => {
    const axiosInstance = axios.create({
        baseURL: HttpService.getURL('agentUrl'),
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000, // 30 seconds
        ...config,
    });

    // Request interceptor for adding auth token
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = store.getState().toolbar.adminToken;
            const userName = getAgentData().agentInfo.user.username;
            if (token && config.headers) {
                config.headers['userName'] = userName;
                let data = getHeaders();
                config.headers = { ...config.headers, ...data }

            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response interceptor for handling errors
    axiosInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;
            // Handle 401 Unauthorized errors (token expired)
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};

// Default API client instance
const apiClient = createApiClient();

// Generic request methods
export const apiRequest = {
    get: (url, config) => {
        return apiClient.get(url, config).then(response => response.data);
    },

    post: (url, data, config) => {
        return apiClient.post(url, data, config).then(response => response.data);
    },

    put: (url, data, config) => {
        return apiClient.put(url, data, config).then(response => response.data);
    },

    patch: (url, data, config) => {
        return apiClient.patch(url, data, config).then(response => response.data);
    },

    delete: (url, config) => {
        return apiClient.delete(url, config).then(response => response.data);
    },
};

// Allow customization of API clients for different services
export const createCustomApiClient = createApiClient;

export default apiClient; 